// extracted by mini-css-extract-plugin
export default {"table_wrap":"DenseTable_table_wrap__rxdeb","table":"DenseTable_table__7NaDn","flushingInfoContainer":"DenseTable_flushingInfoContainer__rQHcw"};